
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/tools/public-discovery-keywords",
      function () {
        return require("private-next-pages/app/tools/public-discovery-keywords.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/app/tools/public-discovery-keywords"])
      });
    }
  